import { useState } from "react";
import { Apis } from "../../lib/Apis";

// --- Hook 1 ---
export const useContracts = () => {
    const createContract = async (contractData) => {
        try {
            const response = await Apis.postContract(contractData);
            return response.data;
        } catch (error) {
            console.error("Error creating contract:", error);
            throw error;
        }
    }
    const getContracts = async (offset = 0, limit = 10, params = {}) => {
        try {
            const response = await Apis.getContracts(offset, limit, params);
            return response.data;
        } catch (error) {
            console.error("Error fetching contracts:", error);
            throw error;
        }
    }
    const getContractById = async (id) => {
        try {
            const response = await Apis.getContractById(id);
            return response.data;
        } catch (error) {
            console.error("Error fetching contract:", error);
            throw error;
        }
    }
    const deleteContract = async (id) => {
        try {
            const response = await Apis.deleteContract(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting contract:", error);
            throw error;
        }
    }
    const updateContract = async (id, data) => {
        try {
            const response = await Apis.updateContract(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating contract:", error);
            throw error;
        }
    }
    const getUserContracts = async (params) => {
        try {
            const response = await Apis.getUserContracts(params);
            return response.data;
        } catch (error) {
            console.error("Error fetching user contracts:", error);
            throw error;
        }
    }
    const getAllContractCategories = async () => {
        try {
            const response = await Apis.getContractCategories(0, 1000);
            return response.data.data;
        } catch (error) {
            console.error("Error fetching contract categories:", error);
            throw error;
        }
    }
    return { 
        createContract, 
        getContracts, 
        deleteContract, 
        getContractById, 
        updateContract, 
        getUserContracts,
        getAllContractCategories
    };
}

// --- Hook 2 ---
export const useContractCategory = () => {
  const [loading, setLoading] = useState(false);

  const addContractCategory = async (categoryData) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("title", categoryData.title);
      if (categoryData.description) {
        formData.append("description", categoryData.description);
      }
      if (categoryData.custom_url) {
        formData.append("custom_url", categoryData.custom_url);
      }

      if (categoryData.image instanceof File) {
        formData.append("image", categoryData.image);
      }

      const response = await Apis.addContractCategory(formData);
      if (response?.status === 201) {
        return response.data;
      } else {
        throw new Error(response?.data?.error || response?.data?.message || "Failed to add category.");
      }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || "Error adding category.");
    } finally {
      setLoading(false);
    }
  };

  const editContractCategory = async (id, categoryData) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", categoryData.title);
      if (categoryData.description !== undefined) {
        formData.append("description", categoryData.description);
      }
      if (categoryData.custom_url) {
        formData.append("custom_url", categoryData.custom_url);
      }

      if (categoryData.image instanceof File) {
        formData.append("image", categoryData.image);
      }

      const response = await Apis.updateContractCategory(id, formData);
      if (response?.status === 200) {
        return response.data;
      } else {
        throw new Error(response?.data?.error || response?.data?.message || "Failed to edit category.");
      }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || "Error editing category.");
    } finally {
      setLoading(false);
    }
  };

  const getContractCategories = async (setCategories, setTotal, offset = 0, limit = 10, search = "") => {
    setLoading(true);
    try {
      const params = {};
      if (search) {
        params.search = search;
      }

      const response = await Apis.getContractCategories(offset, limit, params);

      if (response?.status === 200) {
        setCategories(response.data.data);
        setTotal(response.data.pagination?.totalRecords || response.data.data.length);
        return response;
      } else {
        throw new Error(response?.data?.message || "Failed to fetch categories.");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw new Error(error.message || "Error fetching categories.");
    } finally {
      setLoading(false);
    }
  };

  const deleteContractCategory = async (id) => {
    try {
      setLoading(true);
      const response = await Apis.deleteContractCategory(id);
      return response.data;
    } catch (error) {
      throw new Error(error.message || "Error deleting category.");
    } finally {
      setLoading(false);
    }
  };

  return {
    addContractCategory,
    editContractCategory,
    loading,
    getContractCategories,
    deleteContractCategory
  };
};
